var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.903,
    height: 15.035,
    viewBox: "0 0 11.903 15.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.376,3.445a.627.627,0,0,1-.626-.626V.626A.626.626,0,0,1,7,.626V2.819A.627.627,0,0,1,6.376,3.445Z",
    transform: "translate(-1.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.126,3.445a.627.627,0,0,1-.626-.626V.626a.626.626,0,1,1,1.253,0V2.819A.627.627,0,0,1,11.126,3.445Z",
    transform: "translate(-3.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.876,3.445a.627.627,0,0,1-.626-.626V.626a.626.626,0,0,1,1.253,0V2.819A.627.627,0,0,1,15.876,3.445Z",
    transform: "translate(-4.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.18,2.25H3.723A1.724,1.724,0,0,0,2,3.973v10.18a1.724,1.724,0,0,0,1.723,1.723H12.18A1.724,1.724,0,0,0,13.9,14.153V3.973A1.724,1.724,0,0,0,12.18,2.25Zm-7.048,3.6H8.265a.626.626,0,0,1,0,1.253H5.132a.626.626,0,0,1,0-1.253ZM11.4,12.117H5.132a.626.626,0,0,1,0-1.253H11.4a.626.626,0,0,1,0,1.253Zm0-2.506H5.132a.626.626,0,0,1,0-1.253H11.4a.626.626,0,0,1,0,1.253Z",
    transform: "translate(0 -0.84)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamsActive);
export default __webpack_public_path__ + "static/media/exams-active.fa12ec33003c8ba692f70fbe7cd16c48.svg";
export { ForwardRef as ReactComponent };